import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ZoomLevelService } from './zoom-level.service';

@Injectable({
    providedIn: 'root',
})
export class HeadlineService {
    headline: string[];
    idString = '';
    isMainPage: boolean;
    showCheckbox: boolean = true;

    enabled: boolean = true;
    showIframe: boolean;

    checkboxChanged = new Subject<void>();

    showIframeInspector: boolean = true;
    showIframeNewsfeed: boolean = false;
    showIframeStaffplan: boolean = true;
    showIframeHumanResourcesPlanning: boolean = true;
    showIframeVenues: boolean = false;
    showIframeOrganizer: boolean = false;
    showIframeContactPersons: boolean = false;
    showIframeGlobaleHyperlinks: boolean = true;
    showIframeFoodAllowance: boolean = true;
    showIframeWorkPlanOverview: boolean = true;
    showIframeTravelPlanOverview: boolean = true;
    showIframeCertificationA1: boolean = true;
    showIframeEventProgress: boolean = true;
    showIframeVideoWallOverview: boolean = true;
    showIframeEventRatinglOverview: boolean = true;
    showIframeContactFunctions: boolean = false;
    showIframeEventOverview: boolean = true;
    showIframeWorkTimeRecording: boolean = true;
    showIframeWorkOverview: boolean = true;
    showIframeClassificationConflicts: boolean = true;
    showIframeSkills: boolean = true;
    showIframeYourSkills: boolean = true;
    showIframeYourTrainingOrders: boolean = true;
    showIframeProductGroups: boolean = false;
    showIframeDamageReport: boolean = false;
    showIframeVehicles: boolean = true;
    showIframeTourOverview: boolean = true;
    showIframeVehicleUtilization: boolean = true;
    showIframeBugReport: boolean = true;
    showIframeDressageTask: boolean = true;
    showIframeCurrencyConverter: boolean = true;
    showIframeVacationAbsence: boolean = true;
    showIframeExport: boolean = true;
    showIframeTeam: boolean = false;
    showIframeMyData: boolean = false;
    showIframeVisaWorkPermit: boolean = true;
    showIframeHippoPoints: boolean = true;
    showIframeLoginReset: boolean = true;
    showIframeSystemSettings: boolean = true;
    showIframeGlobalHyperlinks: boolean = true;
    showIframeSystemTranslations: boolean = true;
    showIframeEmailDispatch: boolean = true;

    constructor(private zoomLevelService: ZoomLevelService) {}

    setHeadline(
        headline: string[],
        idString: string,
        isMainPage = true,
        showCheckbox = true
    ) {
        setTimeout(() => {
            this.headline = [...headline];
            this.idString = idString;
            this.isMainPage = isMainPage;
            this.showCheckbox = showCheckbox;

            switch (this.idString) {
                case 'inspector':
                    this.enabled = false;
                    this.showIframe = this.showIframeInspector;
                    break;
                case 'newsfeed':
                    this.enabled = false;
                    this.showIframe = this.showIframeNewsfeed;
                    break;
                case 'staffplan':
                    this.enabled = false;
                    this.showIframe = this.showIframeStaffplan;
                    break;
                case 'venues':
                    this.enabled = false;
                    this.showIframe = this.showIframeVenues;
                    break;
                case 'organizer':
                    this.enabled = false;
                    this.showIframe = this.showIframeOrganizer;
                    break;
                case 'contactPersons':
                    this.enabled = false;
                    this.showIframe = this.showIframeContactPersons;
                    break;
                case 'globaleHyperlinks':
                    this.enabled = false;
                    this.showIframe = this.showIframeGlobaleHyperlinks;
                    break;
                case 'foodAllowance':
                    this.enabled = false;
                    this.showIframe = this.showIframeFoodAllowance;
                    break;
                case 'workPlanOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeWorkPlanOverview;
                    break;
                case 'travelPlanOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeTravelPlanOverview;
                    break;
                case 'certificationA1':
                    this.enabled = false;
                    this.showIframe = this.showIframeCertificationA1;
                    break;
                case 'eventProgress':
                    this.enabled = true;
                    this.showIframe = this.showIframeEventProgress;
                    break;
                case 'videoWallOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeVideoWallOverview;
                    break;
                case 'eventRatingOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeEventRatinglOverview;
                    break;
                case 'contactFunctions':
                    this.enabled = false;
                    this.showIframe = this.showIframeContactFunctions;
                    break;
                case 'eventOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeEventOverview;
                    break;
                case 'workTimeRecording':
                    this.enabled = false;
                    this.showIframe = this.showIframeWorkTimeRecording;
                    break;
                case 'workOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeWorkOverview;
                    break;
                case 'classificationConflicts':
                    this.enabled = false;
                    this.showIframe = this.showIframeClassificationConflicts;
                    break;
                case 'skills':
                    this.enabled = false;
                    this.showIframe = this.showIframeSkills;
                    break;
                case 'yourSkills':
                    this.enabled = false;
                    this.showIframe = this.showIframeYourSkills;
                    break;
                case 'yourTrainingOrders':
                    this.enabled = false;
                    this.showIframe = this.showIframeYourTrainingOrders;
                    break;
                case 'productGroups':
                    this.enabled = false;
                    this.showIframe = this.showIframeProductGroups;
                    break;
                case 'damageReport':
                    this.enabled = true;
                    this.showIframe = this.showIframeDamageReport;
                    break;
                case 'vehicles':
                    this.enabled = false;
                    this.showIframe = this.showIframeVehicles;
                    break;
                case 'tourOverview':
                    this.enabled = false;
                    this.showIframe = this.showIframeTourOverview;
                    break;
                case 'vehicleUtilization':
                    this.enabled = false;
                    this.showIframe = this.showIframeVehicleUtilization;
                    break;
                case 'bugReport':
                    this.enabled = false;
                    this.showIframe = this.showIframeBugReport;
                    break;
                case 'dressageTask':
                    this.enabled = false;
                    this.showIframe = this.showIframeDressageTask;
                    break;
                case 'currencyConverter':
                    this.enabled = false;
                    this.showIframe = this.showIframeCurrencyConverter;
                    break;
                case 'vacationAbsence':
                    this.enabled = false;
                    this.showIframe = this.showIframeVacationAbsence;
                    break;
                case 'export':
                    this.enabled = false;
                    this.showIframe = this.showIframeExport;
                    break;
                case 'team':
                    this.enabled = false;
                    this.showIframe = this.showIframeTeam;
                    break;
                case 'myData':
                    this.enabled = false;
                    this.showIframe = this.showIframeMyData;
                    break;
                case 'visaWorkPermit':
                    this.enabled = false;
                    this.showIframe = this.showIframeVisaWorkPermit;
                    break;
                case 'hippoPoints':
                    this.enabled = false;
                    this.showIframe = this.showIframeHippoPoints;
                    break;
                case 'loginReset':
                    this.enabled = false;
                    this.showIframe = this.showIframeLoginReset;
                    break;
                case 'systemSettings':
                    this.enabled = false;
                    this.showIframe = this.showIframeSystemSettings;
                    break;
                case 'globalHyperlinks':
                    this.enabled = false;
                    this.showIframe = this.showIframeGlobalHyperlinks;
                    break;
                case 'systemTranslations':
                    this.enabled = false;
                    this.showIframe = this.showIframeSystemTranslations;
                    break;
                case 'emailDispatch':
                    this.enabled = false;
                    this.showIframe = this.showIframeEmailDispatch;
                    break;

                default:
                    break;
            }
        }, 1);
    }

    toggleOldSystem() {
        if (this.showIframe) {
            this.zoomLevelService.changeZoom();
        }
        switch (this.idString) {
            case 'inspector':
                this.showIframeInspector = this.showIframe;
                break;
            case 'newsfeed':
                this.showIframeNewsfeed = this.showIframe;
                break;
            case 'staffplan':
                this.showIframeStaffplan = this.showIframe;

                break;
            case 'venues':
                this.showIframeVenues = this.showIframe;

                break;
            case 'organizer':
                this.showIframeOrganizer = this.showIframe;

                break;
            case 'contactPersons':
                this.showIframeContactPersons = this.showIframe;

                break;
            case 'globaleHyperlinks':
                this.showIframeGlobaleHyperlinks = this.showIframe;
                break;
            case 'foodAllowance':
                this.showIframeFoodAllowance = this.showIframe;

                break;
            case 'workPlanOverview':
                this.showIframeWorkPlanOverview = this.showIframe;
                break;
            case 'travelPlanOverview':
                this.showIframeTravelPlanOverview = this.showIframe;
                break;
            case 'certificationA1':
                this.showIframeCertificationA1 = this.showIframe;
                break;
            case 'eventProgress':
                this.showIframeEventProgress = this.showIframe;
                break;
            case 'videoWallOverview':
                this.showIframeVideoWallOverview = this.showIframe;
                break;
            case 'eventRatingOverview':
                this.showIframeEventRatinglOverview = this.showIframe;
                break;
            case 'contactFunctions':
                this.showIframeContactFunctions = this.showIframe;
                break;
            case 'eventOverview':
                this.showIframeEventOverview = this.showIframe;
                break;
            case 'workTimeRecording':
                this.showIframeWorkTimeRecording = this.showIframe;

                break;
            case 'workOverview':
                this.showIframeWorkOverview = this.showIframe;
                break;
            case 'classificationConflicts':
                this.showIframeClassificationConflicts = this.showIframe;
                break;
            case 'skills':
                this.showIframeSkills = this.showIframe;
                break;
            case 'yourSkills':
                this.showIframeYourSkills = this.showIframe;
                break;
            case 'yourTrainingOrders':
                this.showIframeYourTrainingOrders = this.showIframe;
                break;
            case 'productGroups':
                this.showIframeProductGroups = this.showIframe;
                break;
            case 'damageReport':
                this.showIframeDamageReport = this.showIframe;
                break;
            case 'vehicles':
                this.showIframeVehicles = this.showIframe;

                break;
            case 'tourOverview':
                this.showIframeTourOverview = this.showIframe;

                break;
            case 'vehicleUtilization':
                this.showIframeVehicleUtilization = this.showIframe;
                break;
            case 'bugReport':
                this.showIframeBugReport = this.showIframe;
                break;
            case 'dressageTask':
                this.showIframeDressageTask = this.showIframe;
                break;
            case 'currencyConverter':
                this.showIframeCurrencyConverter = this.showIframe;
                break;
            case 'vacationAbsence':
                this.showIframeVacationAbsence = this.showIframe;
                break;
            case 'export':
                this.showIframeExport = this.showIframe;
                break;
            case 'team':
                this.showIframeTeam = this.showIframe;
                break;
            case 'myData':
                this.showIframeMyData = this.showIframe;
                break;
            case 'visaWorkPermit':
                this.showIframeVisaWorkPermit = this.showIframe;
                break;
            case 'hippoPoints':
                this.showIframeHippoPoints = this.showIframe;
                break;
            case 'loginReset':
                this.showIframeLoginReset = this.showIframe;
                break;
            case 'systemSettings':
                this.showIframeSystemSettings = this.showIframe;
                break;
            case 'globalHyperlinks':
                this.showIframeGlobalHyperlinks = this.showIframe;
                break;
            case 'systemTranslations':
                this.showIframeSystemTranslations = this.showIframe;
                break;
            case 'emailDispatch':
                this.showIframeEmailDispatch = this.showIframe;
                break;

            default:
                break;
        }

        this.checkboxChanged.next();
    }
}
